import pegasus from "./00-pegasus";

window.guides = () => {
    return {
        loading: false,
        nextPostLoading: false,
        navigationLinks: null,
        urlList: [],
        currentPostUrl: null,
        nextPost: {},
        currentPostNum: 1,
        numberOfPosts: 0,
        init() {
            const navigation = document.getElementById('guides-navigation');
            let firstItem = navigation.getElementsByTagName('li')[0];
            let firstLink = firstItem.firstElementChild;

            this.navigationLinks = navigation.getElementsByTagName('a');
            this.getPostUrlList();

            this.numberOfPosts = this.navigationLinks.length;

            if(firstLink.getAttribute('href') !== null){
                this.getPostContent(firstLink.getAttribute('href'));
            } else {
                firstItem = firstLink.nextElementSibling.getElementsByTagName('li')[0];
                firstLink = firstItem.firstElementChild;
                this.getPostContent(firstLink.getAttribute('href'));
            }
        },
        getPostUrlList(){
            for(let i = 0; i<this.navigationLinks.length; i++){
                this.urlList[i] = {'title': this.navigationLinks[i].textContent, 'link': this.navigationLinks[i].getAttribute('href')}
            }
        },
        getPostContent(href) {
            const url = new URL(href);
            const searchParams = new URLSearchParams(url.search.slice(1));
            let elements = ['data-post-content', 'data-content-share'];

            if(typeof searchParams !== "undefined" && searchParams !== ""){
                const searchParamsEntries = Object.fromEntries(searchParams.entries());

                if(typeof searchParamsEntries === "object" && Object.keys(searchParamsEntries).length){
                    const customContent = document.querySelectorAll('[data-custom-content]');

                    customContent.forEach(elem => {
                        elem.remove();
                    })

                    elements = ['data-custom-content="'+ searchParamsEntries['guide_content'] +'"'];

                    if(typeof document.querySelector('[data-content-share]') !== "undefined" && document.querySelector('[data-content-share]') !== null){
                        elements.push('data-content-share');
                    }
                }
            }

            this.loading = true;
            pegasus.ajaxContent(href, elements, {}, () => {
                this.loading = false;
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                this.currentPostUrl = href;
                this.getCurrentPostNum(this.navigationLinks);
                this.getNextPostData();
                this.refreshSocial();
            });
        },
        getCurrentPostNum() {    
            const index = this.urlList.map(e => e.link).indexOf(this.currentPostUrl);
            this.currentPostNum = (index) + 1;
        },
        getNextPostData(){
            const nextPost = document.querySelector('.Guide__Next');

            if(typeof this.urlList[this.currentPostNum] == "undefined"){
                nextPost.classList.add("hidden");
                return;
            }

            nextPost.classList.remove("hidden");
            this.nextPostLoading = true;
            this.nextPost.url = this.urlList[this.currentPostNum].link;
            this.nextPost.title = this.urlList[this.currentPostNum].title;
            

            if(typeof this.nextPost.url === "undefined") {
                return;
            }


            pegasus.updateNextPost(this.nextPost.url, this.nextPost.title || null, () => {
                this.nextPostLoading = false;
            });
            
        },
        refreshSocial() {

            a2a.init_all();
        
        }
    }
}